<template>
  <loader :loading="!loaded">
    <slot />
  </loader>
</template>

<script>

import Loader from "../molecules/Loader.vue";

if (window._once_loaded_scripts === undefined) {
  window._once_loaded_scripts = {};
}

const VALID_ATTRIBUTES = ['integrity', 'crossorigin', 'referrerpolicy'];

export default {
  emits: ['loaded'],
  components: { Loader },
  props: {
    src: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: '',
    },
    attributes: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      loaded: this._isLoaded(),
    };
  },
  mounted() {
    // If already fully loaded:
    if (this._isLoaded()) {
      this._ready();
      return;
    }

    const vm = this;
    if (this._isLoading()) {
      window._once_loaded_scripts[vm.src].callbacks.push(
        () => vm.loaded = true
      );
      return;
    }

    window._once_loaded_scripts[vm.src] = {
      callbacks: [() => vm.loaded = true],
      loaded: false,
    };

    const script = document.createElement('script');
    script.setAttribute('type', this.type || 'text/javascript');
    script.setAttribute('src', this.src);

    // Load dynamic attributes
    Object.keys(this.attributes || {})
      .filter((key) => VALID_ATTRIBUTES.includes(key))
      .forEach((key) => script.setAttribute(key, this.attributes[key]));

    script.onload = function () {
      window._once_loaded_scripts[vm.src].loaded = true;
      window._once_loaded_scripts[vm.src].callbacks.forEach(f => f())
    };
    document.head.appendChild(script);
  },
  watch: {
    loaded: {
      handler: function () {
        this._ready();
      },
    },
  },
  methods: {
    _isLoading() {
      return Object.keys(window._once_loaded_scripts).includes(this.src);
    },
    _isLoaded() {
      return this._isLoading() &&  window._once_loaded_scripts[this.src].loaded;
    },
    _ready() {
      this.$emit('loaded');
    },
  },
};
</script>
